import React, {useMemo} from 'react';
import {css, useTheme} from '@mui/material';
import {GetStylesFunction} from '@wallaby-ui/core';
import {Link} from 'react-router-dom';
import {AG_GRID_COMPATIBILITY, JustTooltipFormatter} from '@wallaby-ui/document';

interface Props {
  patientSrcId: string | number | undefined;
}

export const HospitalizationMedbasePortalLinkButton = ({patientSrcId}: Props) => {
  const theme = useTheme();
  const styles = getStyles({theme});

  const demoUrlAddress = 'merie-cs.datlowe.net';
  const isDemo = window.location.host === demoUrlAddress;

  const devUrlAddress = '192.168.210.85';
  const isDev = window.location.hostname === devUrlAddress;

  const stagingUrlAddress = '192.168.210.12';
  const isStaging = window.location.hostname === stagingUrlAddress;

  const srcIdKrupicka = 'example-pat166';
  const srcIdCibulka = 'example-pat137';

  const showHospitalizationMedbasePortalMockedButton =
    (patientSrcId === srcIdKrupicka || patientSrcId === srcIdCibulka) && (isDemo || isDev || isStaging);

  const paramName = 'substance-inn';
  const medicationsKrupicka = ['enoxaparin', 'digoxin', 'amlodipine', 'meropenem', 'metamizole', 'fenoterol', 'ipratropium'];
  const medicationsCibulka = [
    'pantoprazole',
    'potassium chloride',
    'magnesium oxide',
    'sodium chloride',
    'rivaroxaban',
    'amiodarone',
    'spironolactone',
    'telmisartan',
    'hydrocortisone',
    'levothyroxine',
    'metamizole',
    'paracetamol',
    'carbidopa',
    'levodopa',
  ];

  const MEDBASE_PORTAL_URL = 'https://medbaseportal.com/en/#/search?';

  const medbasePortalLink = useMemo(() => {
    const searchParams = new URLSearchParams();
    if (patientSrcId === srcIdKrupicka) {
      medicationsKrupicka.forEach((medication) => {
        searchParams.append(paramName, medication);
      });
    }
    if (patientSrcId === srcIdCibulka) {
      medicationsCibulka.forEach((medication) => {
        searchParams.append(paramName, medication);
      });
    }
    return `${MEDBASE_PORTAL_URL}${searchParams.toString()}`;
  }, [patientSrcId]);

  if (!showHospitalizationMedbasePortalMockedButton) return null;
  return (
    <JustTooltipFormatter
      {...AG_GRID_COMPATIBILITY}
      value={
        <Link tabIndex={0} to={medbasePortalLink} target='_blank' css={styles.button}>
          <img src={'/assets/medbase_logo.png'} alt={'Medbase logo'} css={styles.img} />
        </Link>
      }
      tooltipOverride={'Poslat do Medbase'}
    />
  );
};

HospitalizationMedbasePortalLinkButton.displayName = 'HospitalizationMedbasePortalLinkButton';

const getStyles: GetStylesFunction = (options) => ({
  button: css`
    background-color: white;
    border-radius: 10px;
    padding: 23px 16px;
    margin-left: 10px;
  `,

  img: css`
    width: 40px;
  `,
});
